module.exports = __webpack_public_path__ + "static/img/logo.24d7b04.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = BvKS
// module chunks = 0